import React, { PropTypes } from 'react';
import Transition from 'react-motion-ui-pack';

const propTypes = {
  children: PropTypes.any,
};

const Fading = ({ children }) => (
  <Transition
    component={false}
    measure={false}
    enter={{
      opacity: 1,
    }}
    leave={{
      opacity: 0,
    }}
  >
    {children}
  </Transition>
);

Fading.propTypes = propTypes;
export default Fading;



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/components/shared/fading/Fading.js
 **/